export default "__VITE_PUBLIC_ASSET__374814cb__"